<template>

  <head>

    <meta charset="utf-8" />
    <title>Revenue Streams Report | County Management System</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Revenue management system" name="description" />
    <meta content="County Revenue System" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />

  </head>

  <body @contextmenu.prevent data-sidebar="dark">

  <!-- Begin page -->
  <div id="layout-wrapper">

    <NavigationBar/>

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div id="content" class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <div>
                  <h4 class="mb-sm-0 font-size-18">Revenue Collection by Streams</h4>
                  <p class="text-muted mb-0">Period: {{formatDate(dateFrom)}} to {{formatDate(dateTo)}}</p>
                </div>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript:void(0)">Dashboard</a></li>
                    <li class="breadcrumb-item"><a href="javascript:void(0)">Reports</a></li>
                    <li class="breadcrumb-item active">Revenue by Stream</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>

          <!-- Summary Cards -->
          <div class="row mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Total Collection</span>
                      <h4 class="mb-3">
                        <span class="counter-value text-success">KES {{numberFormat(totalAmount)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-success">
                                                <span class="avatar-title rounded-circle bg-success">
                                                    <i class="bx bx-money font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Revenue Streams</span>
                      <h4 class="mb-3">
                        <span class="counter-value">{{numberFormat(streams.length)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-primary">
                                                <span class="avatar-title rounded-circle bg-primary">
                                                    <i class="bx bx-grid-alt font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Total Transactions</span>
                      <h4 class="mb-3">
                        <span class="counter-value">{{numberFormat(totalTransactions)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-info">
                                                <span class="avatar-title rounded-circle bg-info">
                                                    <i class="bx bx-receipt font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Active Agents</span>
                      <h4 class="mb-3">
                        <span class="counter-value">{{numberFormat(totalAgents)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-warning">
                                                <span class="avatar-title rounded-circle bg-warning">
                                                    <i class="bx bx-user font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- tool bar -->
          <SubCountyReportsToolBar/>
          <!-- end of toolbar -->

          <!-- end page title -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white border-bottom">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <h5 class="card-title mb-0">Revenue Stream Analysis</h5>
                      <small class="text-muted">Showing {{streams.length}} revenue streams</small>
                    </div>
                    <div class="col-md-6">
                      <div class="d-flex justify-content-end gap-2">
                        <button @click="refreshData()" type="button" class="btn btn-outline-primary btn-sm" :disabled="loading">
                          <i class="bx bx-refresh" :class="{'bx-spin': loading}"></i>
                          {{ loading ? 'Refreshing...' : 'Refresh' }}
                        </button>
                        <button data-bs-toggle="modal" data-bs-target=".download-modal" type="button" class="btn btn-success btn-sm">
                          <i class="bx bx-download"></i> Download Report
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-md-8">
                      <div class="d-flex justify-content-start gap-2">
                        <div class="d-flex align-items-center">
                          <label class="form-label mb-0 me-2">From:</label>
                          <input v-model="dateFrom" class="form-control form-control-sm" type="date" style="width: auto;">
                        </div>
                        <div class="d-flex align-items-center">
                          <label class="form-label mb-0 me-2">To:</label>
                          <input v-model="dateTo" class="form-control form-control-sm" type="date" style="width: auto;">
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="text-end">
                        <small class="text-muted">
                          Average per stream: <strong>KES {{getAveragePerStream()}}</strong>
                        </small>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body p-0">
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary mb-3" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <h5>Loading Revenue Streams...</h5>
                    <p class="text-muted">Please wait while we fetch the latest stream data.</p>
                  </div>

                  <div v-else-if="streams.length === 0" class="text-center py-5">
                    <div class="py-4">
                      <i class="bx bx-grid-alt font-size-96 text-muted"></i>
                      <h4 class="mt-3">No Revenue Streams Found</h4>
                      <p class="text-muted">No revenue streams found for the selected period. Try adjusting your date range.</p>
                    </div>
                  </div>

                  <div v-else class="table-responsive">
                    <table class="table table-hover align-middle mb-0">
                      <thead class="table-dark">
                      <tr>
                        <th style="width: 60px;">#</th>
                        <th>Revenue Stream</th>
                        <th class="text-center" style="width: 150px;">Transactions</th>
                        <th class="text-center" style="width: 120px;">Agents</th>
                        <th class="text-end" style="width: 180px;">Amount Collected</th>
                        <th class="text-center" style="width: 150px;">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr :key="index" :value="item" v-for="(item, index) in sortedStreams">
                        <td class="text-center">
                          <span class="badge bg-light text-dark rounded-pill">{{index+1}}</span>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="me-3">
                              <div class="avatar-xs">
                                                                    <span class="avatar-title rounded bg-primary-subtle text-primary">
                                                                        {{getStreamInitials(item.stream)}}
                                                                    </span>
                              </div>
                            </div>
                            <div>
                              <h6 class="mb-0">
                                <a @click="gotToAll('reports-sub-county-streams',item)" href="javascript: void(0);"
                                   class="text-decoration-none">{{formatStreamName(item.stream)}}</a>
                              </h6>
                              <small class="text-muted">{{item.incomeTypePrefix || 'General'}}</small>
                            </div>
                          </div>
                        </td>
                        <td class="text-center">
                          <span class="fw-medium">{{numberFormat(item.transactions)}}</span>
                        </td>
                        <td class="text-center">
                          <span class="badge bg-info">{{numberFormat(item.agents)}}</span>
                        </td>
                        <td class="text-end">
                          <div class="d-flex flex-column align-items-end">
                            <strong class="text-success mb-1">KES {{numberFormat(item.amount)}}</strong>
                            <div class="d-flex align-items-center" style="width: 120px;">
                              <div class="progress flex-grow-1 me-2" style="height: 8px;">
                                <div class="progress-bar bg-success"
                                     :style="`width: ${getPercentageOfTotal(item.amount)}%`">
                                </div>
                              </div>
                              <small class="text-muted" style="min-width: 35px;">{{getPercentageOfTotal(item.amount)}}%</small>
                            </div>
                          </div>
                        </td>
                        <td class="text-center">
                          <button type="button" @click="gotToAll('reports-sub-county-streams-details',item)"
                                  class="btn btn-primary btn-sm">
                            <i class="bx bx-show me-1"></i> View Details
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="card-footer bg-light" v-if="streams.length > 0">
                  <!-- Summary Row -->
                  <div class="row">
                    <div class="col-12">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <strong>{{numberFormat(streams.length)}} Revenue Streams</strong>
                        </div>
                        <div class="text-end">
                          <div><strong>{{numberFormat(totalTransactions)}} Transactions</strong></div>
                          <div><strong>{{numberFormat(totalAgents)}} Agents</strong></div>
                          <div class="text-success"><strong>KES {{numberFormat(totalAmount)}}</strong></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Stream Analysis -->
                  <div v-if="streams.length > 0" class="mt-4 pt-3 border-top bg-light">
                    <div class="row">
                      <div class="col-md-6">
                        <h6 class="mb-3 text-primary">
                          <i class="bx bx-trophy me-2"></i>
                          Top 5 Revenue Streams
                        </h6>
                        <div v-for="(item, index) in getTopStreams()" :key="index" class="mb-3">
                          <div class="d-flex justify-content-between align-items-center mb-1">
                                                        <span class="fw-medium">
                                                            <span class="badge bg-primary me-2">{{ index + 1 }}</span>
                                                            {{ formatStreamName(item.stream) }}
                                                        </span>
                            <strong class="text-success">KES {{ numberFormat(item.amount) }}</strong>
                          </div>
                          <div class="progress" style="height: 12px;">
                            <div class="progress-bar bg-success"
                                 :style="`width: ${getPercentageOfTotal(item.amount)}%`">
                              {{ getPercentageOfTotal(item.amount) }}%
                            </div>
                          </div>
                          <small class="text-muted">
                            {{ numberFormat(item.transactions) }} transactions • {{ numberFormat(item.agents) }} agents
                          </small>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <h6 class="mb-3 text-info">
                          <i class="bx bx-chart-bar me-2"></i>
                          Stream Insights
                        </h6>
                        <ul class="list-unstyled">
                          <li class="mb-2">
                            <i class="bx bx-crown text-warning me-2"></i>
                            <strong>{{ getTopStream()?.stream || 'N/A' }}</strong> leads with
                            <span class="text-success fw-bold">{{ getTopStreamPercentage() }}%</span> of total collection
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-calculator text-primary me-2"></i>
                            Average per stream:
                            <span class="fw-bold">KES {{ getAveragePerStream() }}</span>
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-receipt text-info me-2"></i>
                            Average transactions per stream:
                            <span class="fw-bold">{{ getAverageTransactionsPerStream() }}</span>
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-users text-success me-2"></i>
                            Average agents per stream:
                            <span class="fw-bold">{{ getAverageAgentsPerStream() }}</span>
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-trending-up text-danger me-2"></i>
                            Revenue per transaction:
                            <span class="fw-bold">KES {{ getRevenuePerTransaction() }}</span>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <!-- Performance Distribution -->
                    <div class="row mt-4">
                      <div class="col-12">
                        <h6 class="mb-3">Revenue Distribution</h6>
                        <div class="row">
                          <div class="col-md-4">
                            <div class="card text-center border-success">
                              <div class="card-body py-3">
                                <h4 class="text-success mb-1">{{ getHighPerformers().length }}</h4>
                                <p class="mb-0 text-muted">High Revenue</p>
                                <small class="text-success">>20% of average</small>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="card text-center border-warning">
                              <div class="card-body py-3">
                                <h4 class="text-warning mb-1">{{ getMediumPerformers().length }}</h4>
                                <p class="mb-0 text-muted">Medium Revenue</p>
                                <small class="text-warning">Within 20% of average</small>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="card text-center border-info">
                              <div class="card-body py-3">
                                <h4 class="text-info mb-1">{{ getLowPerformers().length }}</h4>
                                <p class="mb-0 text-muted">Growth Potential</p>
                                <small class="text-info">{{'<20% below average'}}</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>

          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- Download Modal -->
      <div class="modal fade download-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-md modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">Download Revenue Streams Report</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                  <div class="alert alert-info">
                    <h6 class="alert-heading">Report Summary</h6>
                    <ul class="mb-0">
                      <li><strong>{{streams.length}}</strong> Revenue Streams</li>
                      <li><strong>{{numberFormat(totalTransactions)}}</strong> Total Transactions</li>
                      <li><strong>KES {{numberFormat(totalAmount)}}</strong> Total Collection</li>
                    </ul>
                  </div>
                </div>
                <div class="col-12">
                  <label><strong>Report Date Range</strong></label>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-xl-6 col-sm-6">
                      <div class="mb-3">
                        <label class="form-label">Date From</label>
                        <input v-model="dateFrom" class="form-control" placeholder="Start date" type="date">
                      </div>
                    </div>

                    <div class="col-xl-6 col-sm-6">
                      <div class="mb-3">
                        <label class="form-label">Date To</label>
                        <input v-model="dateTo" class="form-control" placeholder="End date" type="date">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <label><strong>Select File Type</strong></label>
                  <select class="form-select" v-model="documentType">
                    <option value="">Select Document Type</option>
                    <option value="pdf">PDF file</option>
                    <option value="excel">Excel File</option>
                  </select>
                </div>
                <div class="col-12">
                  <button @click="downloadReportsStreams()" type="button"
                          class="btn btn-primary w-100 mt-4" :disabled="!documentType || downloading">
                    <i class="bx bxs-download font-size-16 me-2"></i>
                    <span>{{download}}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">©County Revenue System</div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Developed by County IT Department
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->

  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>

  </body>

</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import {biller, execute, executeDownload} from "@/api";
import router from "@/router";
import moment from "moment";
import ToolBar from "@/components/sbp/ToolBar";
import ToolBarStreams from "@/components/reports/streams/ToolBar";
import SubCountyReportsToolBar from "@/components/reports/collectionbysubcounties/SubCountyReportsToolBar";

export default {
  name: "ReportsStreams",
  components: {SubCountyReportsToolBar, ToolBarStreams, ToolBar, NavigationBar},
  data() {
    return{
      download:'Download Report',
      downloading: false,
      loading: false,
      documentType:'',
      totalTransactions:0,
      totalAmount:0,
      totalAgents:0,
      subCountyName:'',
      subCountyID:'',

      dateTo:'',
      dateFrom:'',

      message:'',
      alert:{
        success: false,
        info: false,
        failed:false
      },
      contact: {
        email: ''
      },
      password:'',
      streams: [],
    }
  },
  mounted() {

    this.dateTo = sessionStorage.getItem("dateTo")
    this.dateFrom = sessionStorage.getItem("dateFrom")

    this.subCountyName = sessionStorage.getItem("subCountyName")
    this.subCountyID = sessionStorage.getItem("subCountyID")

    this.$watch('dateFrom', function (newValue) {
      if (this.dateFrom === '' || this.dateTo === '') {
        return;
      } else {
        this.getReportsStreams()
      }
    })

    this.$watch('dateTo', function (newValue) {
      if (this.dateFrom === '' || this.dateTo === '') {
        return;
      } else {
        this.getReportsStreams()
      }
    })

    this.getReportsStreams()
    this.menuAccess()
  },
  computed: {
    sortedStreams() {
      return [...this.streams].sort((a, b) => Number(b.amount) - Number(a.amount));
    }
  },
  methods: {

    // Helper methods for better UX
    formatStreamName(name) {
      if (!name) return 'Unknown Stream';
      return name.toLowerCase().split(' ').map(word =>
          word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ');
    },

    getStreamInitials(name) {
      if (!name) return '?';
      return name.split(' ').map(word => word.charAt(0)).join('').substring(0, 2).toUpperCase();
    },

    getPercentageOfTotal(amount) {
      if (this.totalAmount === 0) return 0;
      return ((Number(amount) / this.totalAmount) * 100).toFixed(1);
    },

    getAveragePerStream() {
      if (this.streams.length === 0) return '0';
      return this.numberFormat(Math.round(this.totalAmount / this.streams.length));
    },

    getAverageTransactionsPerStream() {
      if (this.streams.length === 0) return '0';
      return this.numberFormat(Math.round(this.totalTransactions / this.streams.length));
    },

    getAverageAgentsPerStream() {
      if (this.streams.length === 0) return '0';
      return this.numberFormat(Math.round(this.totalAgents / this.streams.length));
    },

    getRevenuePerTransaction() {
      if (this.totalTransactions === 0) return '0';
      return this.numberFormat(Math.round(this.totalAmount / this.totalTransactions));
    },

    getTopStreams() {
      return this.sortedStreams.slice(0, 5);
    },

    getTopStream() {
      if (this.streams.length === 0) return null;
      return this.streams.reduce((max, current) =>
          Number(current.amount) > Number(max.amount) ? current : max
      );
    },

    getTopStreamPercentage() {
      const topStream = this.getTopStream();
      if (!topStream || this.totalAmount === 0) return '0';
      return this.getPercentageOfTotal(topStream.amount);
    },

    getHighPerformers() {
      const average = this.totalAmount / this.streams.length;
      return this.streams.filter(item =>
          Number(item.amount) > (average * 1.2)
      );
    },

    getMediumPerformers() {
      const average = this.totalAmount / this.streams.length;
      return this.streams.filter(item => {
        const amount = Number(item.amount);
        return amount >= (average * 0.8) && amount <= (average * 1.2);
      });
    },

    getLowPerformers() {
      const average = this.totalAmount / this.streams.length;
      return this.streams.filter(item =>
          Number(item.amount) < (average * 0.8)
      );
    },

    refreshData() {
      this.getReportsStreams();
    },

    formatDate(date) {
      if (!date) return '';
      let d = new Date(date);
      let day = d.getDate();
      let month = d.toLocaleString('en-US', { month: 'short' });
      let year = d.getFullYear();

      let suffix = '';
      if (day % 10 === 1 && day !== 11) {
        suffix = 'st';
      } else if (day % 10 === 2 && day !== 12) {
        suffix = 'nd';
      } else if (day % 10 === 3 && day !== 13) {
        suffix = 'rd';
      } else {
        suffix = 'th';
      }
      return `${day}${suffix} ${month} ${year}`;
    },

    menuAccess(){
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Reports Sub County Revenue Streams");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
      execute(data,biller)
          .then((res) => {
            // Success
          })
          .catch((e) => {
            console.error("Menu access error:", e);
          });
    },

    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num || 0)
    },

    gotToAll(route,item) {
      const incomeTypePrefix = item.incomeTypePrefix || "NULL";

      sessionStorage.setItem("currentPage",route)
      sessionStorage.setItem("dateTo", this.dateTo)
      sessionStorage.setItem("dateFrom", this.dateFrom)
      sessionStorage.setItem("subCountyName", "")
      sessionStorage.setItem("subCountyID", "")

      sessionStorage.setItem("incomeTypeDescription", "")
      sessionStorage.setItem("feeDescription", "")
      sessionStorage.setItem("incomeTypePrefix", incomeTypePrefix)

      router.push(route)
    },

    downloadReportsStreams(){
      if (!this.documentType) {
        alert('Please select a document type');
        return;
      }

      this.downloading = true;
      this.download = "Please wait.."

      const data = new FormData();
      data.append("function", "downloadReportsStreams");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("subCountyID", this.subCountyID);
      data.append("documentType", this.documentType);

      executeDownload(data,biller)
          .then(response => {
            this.download = "Download Report"
            this.downloading = false;

            const link = document.createElement('a');
            link.href = URL.createObjectURL(response.data);
            const extension = this.documentType === 'pdf' ? 'pdf' : 'csv';
            link.download = `${this.dateFrom}_to_${this.dateTo}_Revenue_Streams.${extension}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(e => {
            this.download = "Download Report"
            this.downloading = false;
            console.error("Download error:", e);
            alert("Failed to download report. Please try again.");
          });
    },

    getReportsStreams(){
      this.loading = true;
      this.streams.splice(0)

      const data = new FormData();
      data.append("function", "getReportsStreams");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("subCountyID", this.subCountyID);

      execute(data,biller)
          .then((res) =>{
            this.loading = false;
            this.alert.info = false

            if (res.data.success) {
              this.streams = res.data.data.streams || []

              const totals = this.streams.reduce(
                  (accumulator, currentStream) => {
                    const transactions = parseInt(currentStream.transactions) || 0;
                    const amount = parseInt(currentStream.amount) || 0;
                    const agents = parseInt(currentStream.agents) || 0;

                    accumulator.totalTransactions += transactions;
                    accumulator.totalAmount += amount;
                    accumulator.totalAgents += agents;

                    return accumulator;
                  },
                  {
                    totalTransactions: 0,
                    totalAmount: 0,
                    totalAgents: 0,
                  }
              );

              this.totalTransactions = totals.totalTransactions
              this.totalAmount = totals.totalAmount;
              this.totalAgents = totals.totalAgents;

            } else {
              console.log("API returned success: false", res.data.message);
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.loading = false;
            console.error("API Error:", e);
            this.message = e.message
            alert("Failed to load revenue streams data. Please check your connection and try again.");
          });
    },
  }
}
</script>

<style scoped>
.card-h-100 {
  height: 100%;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fa;
}

.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 12px;
  font-weight: 600;
}

.bg-primary-subtle {
  background-color: rgba(13, 110, 253, 0.1) !important;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.bx-spin {
  animation: spin 1s linear infinite;
}

.progress {
  background-color: #f3f3f3;
}

.badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}
</style>